import { authStore } from '@amazd/common/utils/auth';

export const useAuthStore = authStore;

export function useAuthError() {
  const message = useAuthStore((state) => state.errorMessage);
  return message;
}
